module.exports = __webpack_public_path__ + "static/img/twjd-sdo2-1.05038cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo2-1.png
// module id = 149
// module chunks = 0